import Vue from "vue";

/* tslint:disable:no-var-requires */

// https://github.com/vuejs/vue-loader/releases/tag/v13.0.0

// Utilities
Vue.component("Clipboard", require("@/components/utils/Clipboard").default);
Vue.component("Loader", require("@/components/utils/Loader").default);
Vue.component("Pagination", require("@/components/utils/pagination/Pagination").default);
Vue.component("QrCode", require("@/components/utils/QrCode").default);
Vue.component("TableWrapper", require("@/components/utils/TableWrapper").default);
Vue.component("TransactionAmount", require("@/components/utils/TransactionAmount").default);

// Links
Vue.component("LinkBlock", require("@/components/links/LinkBlock").default);
Vue.component("LinkTransaction", require("@/components/links/LinkTransaction").default);
Vue.component("LinkWallet", require("@/components/links/LinkWallet").default);

// Tables
Vue.component("TableDelegates", require("@/components/tables/DelegateMonitor").default);

Vue.component("TableBlocksDesktop", require("@/components/tables/Blocks").default);
Vue.component("TableTransactionsDesktop", require("@/components/tables/Transactions").default);
Vue.component("TableAccountsDesktop", require("@/components/tables/Accounts").default);
Vue.component("TableAccountsSearchDesktop", require("@/components/tables/AccountsSearch").default);
Vue.component("TableDelegatesDesktop", require("@/components/tables/Delegates").default);
Vue.component("TableAppsDesktop", require("@/components/tables/Apps").default);
Vue.component("TableDevsDesktop", require("@/components/tables/Devs").default);
Vue.component("TableRpcsDesktop", require("@/components/tables/Rpcs").default);

Vue.component("TableBlocksMobile", require("@/components/tables/mobile/Blocks").default);
Vue.component("TableTransactionsMobile", require("@/components/tables/mobile/Transactions").default);
Vue.component("TableAccountsMobile", require("@/components/tables/mobile/Accounts").default);
Vue.component("TableAccountsSearchMobile", require("@/components/tables/mobile/AccountsSearch").default);
Vue.component("TableDelegatesMobile", require("@/components/tables/mobile/Delegates").default);

// Misc.
Vue.component("ContentHeader", require("@/components/ContentHeader").default);
Vue.component("DisclaimerModal", require("@/components/DisclaimerModal").default);
Vue.component("Modal", require("@/components/Modal").default);
Vue.component("SvgIcon", require("@/components/SvgIcon").default);
